import 'i18next';
import {
  IsArray,
  IsNotEmpty,
  IsOptional,
  MaxLength,
  MinLength,
  ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

import { t } from '@app-velocity/i18n';

import { TeamMemberDto } from './TeamMemberDto';

export class TeamCreateDto {
  @IsNotEmpty({
    message: t('teams:validation.name_cannot_be_empty'),
  })
  @MinLength(3, {
    message: t('teams:validation.name_too_short', {
      minLength: 3,
    }),
  })
  @MaxLength(50, {
    message: t('teams:validation.name_too_long', {
      maxLength: 50,
    }),
  })
  name = '';

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => TeamMemberDto)
  members?: TeamMemberDto[];
}
